import React from "react";
import MemberShipCard from "./MemberShipCard";
import { useAccount } from "../../Contexts/AccountContext";

export default () => {
    const { dictionary, memberships, currentMembership, isAuthenticated } = useAccount();

    return <div className="h-100">
        {memberships && currentMembership && <div className="row">
            <MemberShipCard membership={currentMembership} />
        </div>}

        {memberships && !currentMembership && <div className="alert alert-default bg-white">
            <h4 className="alert-heading">{dictionary.get('MyAccount:Membership:NotFound') || "No Memberships Found"}</h4>
            <p>{dictionary.get('MyAccount:Membership:NotFoundDescription') || "You do not have any memberships at this time."}</p>
            </div>
        }

        {isAuthenticated == false && <div className="alert alert-default bg-white">
            <h4 className="alert-heading">{dictionary.get('MyAccount:Membership:Redirecting') || "Redirecting to Login"}</h4>
            <p>{dictionary.get('MyAccount:Membership:RedirectingDescription') || "Not logged in.  Redirecting you to the login provider."}</p>
            </div>
        }

        {(isAuthenticated == null || isAuthenticated) && !memberships && <div className="alert alert-default bg-white">
            <h4 className="alert-heading">{dictionary.get('MyAccount:Membership:Loading') || "Loading Memberships..."}</h4>
            <p>{dictionary.get('MyAccount:Membership:Loading') || "Please wait while we load your membership information."}</p>
            </div>
        }
    </div>
}